// This file is manually maintained and provides runtime configuration for the generated client
// It's referenced by runtimeConfigPath in openapi-ts.config.ts
//
// Note: This provides a default configuration. Applications should configure the baseURL
// by calling client.setConfig() with their framework-specific environment variables.

import axios from 'axios';

import type { CreateClientConfig } from './generated/client.gen';

/**
 * Runtime configuration for the API client.
 * This function is called during client initialization to set up default configuration.
 *
 * Applications should configure the baseURL by calling client.setConfig() after import.
 * This keeps the API client package framework-agnostic.
 */
export const createClientConfig: CreateClientConfig = (override) => {
  // Create axios instance (baseURL will be set by the application)
  const axiosInstance = axios.create();

  return {
    ...override,
    axios: axiosInstance,
  };
};
